module.exports = __webpack_public_path__ + "img/fr1.8bba0f49.png";